import { RouterModule, Routes } from '@angular/router';

import { AuthGuardService } from '../shared/services/auth-guard.service';

import { GatewayCommissioningGuardService } from './gateway-commissioning.guard.service';
import { GatewayCommissioningComponent } from './gateway-commissioning/gateway-commissioning.component';

export const gatewayCommissioningRoutes: Routes = [
  {
    path: 'commissioning',
    component: GatewayCommissioningComponent,
    canActivate: [AuthGuardService, GatewayCommissioningGuardService],
  },
];

export const GatewayCommissioningRouting = RouterModule.forChild(gatewayCommissioningRoutes);
